"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'BasisCopyright',
  // 版权信息
  props: {
    beginYear: {
      type: Number,
      default: 2020
    },
    customStyle: {
      type: Object,
      default: undefined
    },
    text: {
      type: String,
      default: '万视智能 | 广州万视智能科技有限责任公司'
    }
  },
  computed: {
    curYear() {
      const year = new Date().getFullYear();
      return year === this.beginYear ? year : `${this.beginYear}-${year}`;
    }
  }
};